/**
 * Sesión de la demo.
 *
 * No hay token ni backend: esto es sólo la identidad que el tablero muestra
 * arriba a la derecha y en el pie del panel lateral. Se guarda serializada, así
 * que la clase existe para volver a hidratarla sin confiar en lo que hubiera en
 * el almacenamiento (una versión anterior, un usuario que editó a mano).
 */
export interface ISession {
  correo: string;
}

export class Session implements ISession {

  public correo: string;

  constructor(data?: Partial<ISession>) {
    this.correo = data?.correo ?? '';
  }

  /**
   * Hidrata lo leído del almacenamiento. Devuelve `null` en vez de una sesión a
   * medias: arrastrar un objeto vacío por el tablero es peor que volver a pedir
   * el acceso.
   */
  public static desde(raw: unknown): Session | null {
    if (!raw || typeof raw !== 'object') {
      return null;
    }

    const data = raw as Partial<ISession>;

    return data.correo ? new Session(data) : null;
  }
}
